import * as React from 'react';
import Form from 'react-bootstrap/Form';
import {ArrowLeft} from '../../common/btns';

const headerCss = require('../../common/header.css').default;
const css = require('./viewer.css').default;

export default function ({member, onOk}: {
    member: member,
    onOk: () => void,
}) {
    return (
    <>
        <div id={headerCss.header}>
            <ArrowLeft width={25} height={25} onClick={onOk}/>
            <div>權限</div>
        </div>
        <table id={css.table}>
            <tr>
                <td>姓名</td>
                <td>{member.name}</td>
            </tr>
            <tr>
                <td>gmail</td>
                <td>{member.email}</td>
            </tr>
            <tr>
                <td>管理員</td>
                <td><Form.Check type='checkbox' checked={member.isAdmin}/></td>
            </tr>
        </table>
    </>);
}

type member = {
    name: string,
    email: string,
    isAdmin: boolean,
}
